import { Api } from "./api"

const PATH = 'client' 
const ENDPOINTS = {
    Liste:'liste',
    // Store:'store',
    Show:'show',
    Update:'update',
    Delete:'delete',
    Enable:'enable',
    Disable:'disable',
    Banish:'banish',
}

const getClients = (signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Liste}`, signal)
}

const getClient = (id,signal) => {
    return Api.get(`${PATH}/${id}/${ENDPOINTS.Show}`, signal)
}

// const storeClient = (payload,signal) => {
//     return Api.post(`${PATH}/${ENDPOINTS.Store}`,payload, signal)
// }

const updateClient = (id,payload,signal) => {
    return Api.update(`${PATH}/${id}/${ENDPOINTS.Update}`,payload, signal)
}

const deleteClient = (id,signal) => {
    return Api.erase(`${PATH}/${id}/${ENDPOINTS.Delete}`, signal)
}
const enable = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Enable}/${id}`, signal)
}

const disable = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Disable}/${id}`, signal)
}

const banish = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Banish}/${id}`, signal)
}

export const ClientApi={
    getClients,
    getClient,
    deleteClient,
    updateClient,
    banish,
    disable,
    enable
    
}